import { Navigate, Outlet, useLocation } from "react-router-dom";

export default function AdminProtectedRoute() {
  const location = useLocation();
  
  const adminToken = localStorage.getItem("adminToken");
  const isAdmin = localStorage.getItem("isAdmin") === "true";
  
  console.log("🔒 AdminProtectedRoute check:", {
    path: location.pathname,
    adminToken: adminToken ? "✓" : "✗",
    isAdmin
  });
  
  // If no admin token, redirect to admin login
  if (!adminToken || !isAdmin) {
    console.log("⚠️ No admin token - redirecting to admin login");
    return <Navigate to="/adminLogin" state={{ from: location }} replace />;
  }
  
  // If has admin token, allow access
  console.log("✅ Admin access granted");
  return <Outlet />;
}